import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";
import { useWorkItemAgreements } from "../../../data/WorkItemAgreementsHook";
import "./WorkItemEntry.css";
import EngineerAvailability from "../../engineerAvailability/EngineerAvailability";

function ReconnectionEntry() {
  const workOrdersRepository = useWorkOrders();
  const workItemAgreementsRepository = useWorkItemAgreements();

  const workOrder = workOrdersRepository.getEntry();

  const anyTimeSlot = { id: "PATS003", title: "Any time" };

  const updateAppointment = (date, slot, agreedoutsidesla) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      agreedoutsidesla,
      preferredAppointmentDate: date,
      preferredAppointmentSlot: slot.id,
      preferredAppointmentSlotTitle: slot.title,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateAppointmentConfirmed = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      preferredAppointmentDate: "",
      preferredAppointmentSlot: anyTimeSlot.id,
      preferredAppointmentSlotTitle: anyTimeSlot.title,
      appointmentConfirmed: e.target.value,
      appointmentConfirmedTitle: e.target.selectedOptions[0].text,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateJobSpecificAccessNotes = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const handleSuppliesToReconnectChange = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, [e.target.id]: !current[e.target.id] };
    workOrdersRepository.setEntry(revised);
  };

  const workItemAgreements =
    workItemAgreementsRepository.getWorkItemAgreements();

  const appointmentData = {
    appointmentConfirmed: workOrder.appointmentConfirmed,
    preferredAppointmentDate: workOrder.preferredAppointmentDate,
    slahours: workOrder.slahours,
    preferredAppointmentSlotTitle: workOrder.preferredAppointmentSlotTitle,
  };

  return (
    <div className="work-order-item-section">
      <h3>Reconnection Work Item Details</h3>
      <Container className="work-order-item-container">
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="suppliesToReconnect">
              <Form.Label>Supplies To Reconnect</Form.Label>
              <Form.Check
                type="checkbox"
                id="reconnectelectricity"
                label="Reconnect Electricity"
                checked={workOrder.reconnectelectricity}
                onChange={handleSuppliesToReconnectChange}
              />
              <Form.Check
                type="checkbox"
                id="reconnectheat"
                label="Reconnect Heat"
                checked={workOrder.reconnectheat}
                onChange={handleSuppliesToReconnectChange}
              />
              <Form.Check
                type="checkbox"
                id="reconnecthotwater"
                label="Reconnect Hot Water"
                checked={workOrder.reconnecthotwater}
                onChange={handleSuppliesToReconnectChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="appointmentConfirmedGroup">
              <Form.Label>
                Will this be an agreed or not agreed appointment?
              </Form.Label>
              <Form.Select
                value={workOrder.appointmentConfirmed}
                onChange={updateAppointmentConfirmed}
              >
                {workItemAgreements.map((nextItem) => (
                  <option key={nextItem.id} value={nextItem.id}>
                    {nextItem.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <EngineerAvailability 
              updateAppointment={updateAppointment}
              appointmentData={appointmentData}
            />

            <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
              <Form.Label>Job Specific Access Notes</Form.Label>
              <Form.Control
                as="input"
                value={workOrder.jobSpecificAccessNotes}
                onChange={updateJobSpecificAccessNotes}
              />
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ReconnectionEntry;
